<template>
  <div class="dual-select">
    <div class="row">
      <div class="col-auto pe-0">
        <slot name="header-a"></slot>
        <ModeToggle
          v-if="nftEnabled"
          a="DeFi"
          b="NFT"
          @toggle="toggleInputMode"
        ></ModeToggle>
      </div>
      <div
        class="col text-end px-0 animate__animated animate__fadeIn"
        v-if="mode === 'token'"
        :key="`${tokenA.address}-${tokenABalance}`"
      >
        <small class="small"
          >
          {{
            (
              tokenABalance / Math.pow(10, this.tokenA?.decimals) || 0
            ).toLocaleString()
          }}
          {{ tokenA?.symbol?.toUpperCase().replace(/\0/g, "") }}</small
        >
      </div>
      <div
        class="col-auto animate__animated animate__fadeIn"
        v-if="mode === 'token'"
      >
        <button
          @click="setHalf"
          class="quick-btn d-inline-block btn btn-white btn-sm me-2"
        >
          HALF
        </button>
        <button
          @click="setMax"
          class="quick-btn d-inline-block btn btn-white btn-sm"
        >
          MAX
        </button>
      </div>
    </div>

    <TokenSelect
      id="A"
      v-if="mode === 'token'"
      :token="tokenA"
      @input="onUpdateAAmount"
      @tokenChange="updateTokenA"
      class="input mt-3"
    ></TokenSelect>
    <SelectNFTContainer
      v-else-if="mode === 'nft'"
      @selected="updateNFT"
      class="input mt-3"
    ></SelectNFTContainer>

    <div class="row" v-if="toggleSwap">
      <div class="col">
      </div>
      <div class="col-auto swap-toggle" @click="toggleAToB">
        <i class="fa fa-arrow-right-arrow-left fa-rotate-90 mt-2"></i>
      </div>
      <div class="col">
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <hr />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <h4 class="mb-0">
          <slot name="header-b"></slot>
        </h4>
      </div>
      <div class="col-auto" :key="`${tokenB.address}-${tokenBBalance}`">
        <small class="small"
          >{{
            (
              tokenBBalance / Math.pow(10, this.tokenB?.decimals) || 0
            ).toLocaleString()
          }}
          {{ tokenB?.symbol?.toUpperCase().replace(/\0/g, "") }}</small
        >
      </div>
    </div>
    <TokenSelect
      id="B"
      :token="tokenB"
      @tokenChange="updateTokenB"
      @input="onUpdateBAmount"
      class="output mt-3"
      :disabled="!bEnabled"
    ></TokenSelect>
  </div>
</template>

<script>
import TokenSelect from "@/components/token/TokenSelect.vue";
import { web3 } from "@project-serum/anchor";
import ModeToggle from "@/components/common/ModeToggle.vue";
import SelectNFTContainer from "@/components/nft/SelectNFTContainer.vue";
import { defaultSOL } from "@/api/token_swap/constants";
import { mapStores } from "pinia";
import { useWalletStore } from "@/pinia";

export default {
  name: "DualSelect",
  components: { SelectNFTContainer, ModeToggle, TokenSelect },
  props: {
    nftEnabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    bEnabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toggleSwap: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      mode: "token",
      tokenABalance: 0,
      tokenBBalance: 0,
      loadingBalances: false,
    };
  },
  computed: {
    tokenA: function () {
      return this.$store.state.swap.tokenA;
    },
    tokenB: function () {
      return this.$store.state.swap.tokenB;
    },
    ...mapStores(useWalletStore),
  },
  methods: {
    toggleInputMode: function () {
      this.mode = this.mode === "token" ? "nft" : "token";
    },

    updateUri: function () {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("inMint", this.tokenA.address);
      searchParams.set("outMint", this.tokenB.address);
      window.history.replaceState(
        history.state,
        null,
        "?" + searchParams.toString()
      );
    },

    toggleAToB: function () {
      console.log("toggleAToB", {
        tokenA: this.tokenA,
        tokenB: this.tokenB,
      });

      const tempA = Object.assign({}, this.tokenA);
      const tempB = Object.assign({}, this.tokenB);

      this.$store.dispatch("swap/setTokenA", tempB);
      this.$store.dispatch("swap/setTokenB", tempA);

      this.onUpdate();
    },
    setHalf: function () {
      this.$store.commit(
        "swap/setTokenAAmount",
        Math.floor(this.tokenABalance / 2)
      );
      this.onUpdateAAmount();
    },
    setMax: function () {
      this.$store.commit("swap/setTokenAAmount", this.tokenABalance);
      this.onUpdateAAmount();
    },

    getTokenBalances: async function () {
      if (
        !this.walletStore.isConnected ||
        !this.tokenA?.address ||
        !this.tokenB?.address ||
        this.loadingBalances
      )
        return;

      this.loadingBalances = true;

      const owner = this.walletStore.address;
      const ataA = this.$store.state.solana.tokenClient.getAssociatedTokenPDA(
        new web3.PublicKey(this.tokenA?.address),
        owner,
        new web3.PublicKey(this.tokenA?.programID)
      );
      const ataB = this.$store.state.solana.tokenClient.getAssociatedTokenPDA(
        new web3.PublicKey(this.tokenB?.address),
        owner,
        new web3.PublicKey(this.tokenB?.programID)
      );

      const resp =
        await this.$store.state.solana.client.getMultipleParsedAccounts(
          [
            owner, //SOL
            ataA, //TokenA
            ataB, //TokenB
          ],
          { commitment: "processed" }
        );

      let nativeSol = 0
      if (resp.value[0]) {
        if (
          this.tokenA.address.toString() ===
          "So11111111111111111111111111111111111111112"
        ) {
          this.tokenABalance = Number(resp.value[0].lamports);
        }
        if (
          this.tokenB.address.toString() ===
          "So11111111111111111111111111111111111111112"
        ) {
          this.tokenBBalance = Number(resp.value[0].lamports);
        }
        nativeSol = resp.value[0].lamports
        this.$store.commit(
          "cache/add_user_token",
          defaultSOL(this.tokenA.address, Number(resp.value[0].lamports))
        );
      }

      if (resp.value[1]) {
        if (
          this.tokenA.address.toString() ===
          "So11111111111111111111111111111111111111112"
        ) {
          const newAmount = Number(
            resp.value[1].data?.parsed?.info.tokenAmount?.amount
          ) + Number(nativeSol);
          this.tokenABalance = newAmount;
          this.$store.commit(
            "cache/add_user_token",
            defaultSOL(this.tokenA.address, newAmount)
          );
        } else {
          this.tokenABalance = Number(
            resp.value[1].data?.parsed?.info.tokenAmount?.amount
          );
          this.$store.commit("cache/add_user_token", {
            account: resp.value[1],
            pubkey: this.tokenA.address,
          });
        }
      }

      if (resp.value[2]) {
        if (
          this.tokenB.address.toString() ===
          "So11111111111111111111111111111111111111112"
        ) {
          const newAmount = Number(
            resp.value[2].data?.parsed?.info.tokenAmount?.amount
          ) + Number(nativeSol);
          this.tokenBBalance = newAmount;
          this.$store.commit(
            "cache/add_user_token",
            defaultSOL(this.tokenB.address, newAmount)
          );
        } else {
          this.tokenBBalance = Number(
            resp.value[2].data?.parsed?.info.tokenAmount?.amount
          );
          this.$store.commit("cache/add_user_token", {
            account: resp.value[2],
            pubkey: this.tokenB.address,
          });
        }
      }

      this.loadingBalances = false;
    },

    updateNFT: async function (nft) {
      //TODO
      console.log("NFT update", nft);

      if (!nft.collection) {
        this.$toastr.e("Missing collection data", "Invalid NFT collection");
        return;
      }

      //TODO Enable
      // const nftPoolPk = this.nftFraction.getCollectionPoolKey(new web3.PublicKey(nft.collection))
      //
      // const pool = await this.nftFraction.getPool(nftPoolPk)
      //
      // this.$set(this.form, 'tokenA', pool.tokenMint)
      // localStorage.setItem("swap:default_token_a", JSON.stringify(this.tokenA))
      //
      // this.getTokenABalance()
      // this.onUpdate()
    },

    onUpdateAAmount: function () {
      this.$emit("inputA");
    },

    onUpdateBAmount: function () {
      this.$emit("inputB");
    },

    updateTokenA: async function (token) {
      if (!token.programID || token.decimals === 0) {
        const tokenAInfo =
          await this.$store.state.solana.client.getParsedAccountInfo(
            new web3.PublicKey(token.address)
          );
        token.programID = tokenAInfo?.value?.owner.toString();
        token.decimals = tokenAInfo?.value?.data?.parsed?.info.decimals;
      }

      this.$store.dispatch("swap/setTokenA", token);
      this.$store.commit("swap/setTokenBAmount", 0);

      this.getTokenBalances();
      this.onUpdateAAmount();
      this.onUpdate();
    },
    updateTokenB: async function (token) {
      if (!token.programID || token.decimals === 0) {
        const tokenAInfo =
          await this.$store.state.solana.client.getParsedAccountInfo(
            new web3.PublicKey(token.address)
          );
        token.programID = tokenAInfo?.value?.owner.toString();
        token.decimals = tokenAInfo?.value?.data?.parsed?.info.decimals;
      }

      this.$store.dispatch("swap/setTokenB", token);
      this.$store.commit("swap/setTokenAAmount", 0);

      this.getTokenBalances();
      this.onUpdateBAmount();
      this.onUpdate();
    },

    onUpdate: function () {
      this.updateUri();
      this.$emit("update");
    },

    /**
     * Checks local storage & then route query params to set our tokens
     * @returns {Promise<void>}
     */
    handleQueryInput: async function () {
      const urlParams = new URLSearchParams(window.location.search);

      if (this.$route.query.inMint || urlParams.get('inMint')) {
        const inMint = this.$route.query.inMint ?? urlParams.get('inMint')
        const cached =
          this.$store.state.cache.tokenMap[inMint];
        let token;
        if (cached && cached.decimals > 0) {
          token = Object.assign(
            {
              address: new web3.PublicKey(inMint),
              amount: 0,
            },
            this.$store.state.cache.tokenMap[inMint]
          );
        } else {
          const mint = new web3.PublicKey(inMint);
          const ts = await this.$store.state.solana.client.getParsedAccountInfo(
            mint
          );

          token = Object.assign(
            cached || {
              address: mint,
              amount: 0,
              decimals: ts?.value?.data?.parsed.info.decimals,
              name: "Unknown",
              symbol: "Unknown",
              programID: ts?.value?.owner.toString(),
            },
            {
              address: new web3.PublicKey(inMint),
              amount: 0,
              decimals: ts?.value?.data?.parsed.info.decimals,
            }
          );
        }

        console.log("setting query inMint", token);
        this.updateTokenA(token);
      }
      
      if (this.$route.query.outMint || urlParams.get('outMint')) {
        const outMint = this.$route.query.outMint ?? urlParams.get('outMint')
        const cached =
          this.$store.state.cache.tokenMap[outMint];
        let token;
        if (cached && cached.decimals > 0) {
          token = Object.assign(
            {
              address: new web3.PublicKey(outMint),
              amount: 0,
            },
            this.$store.state.cache.tokenMap[outMint]
          );
        } else {
          const mint = new web3.PublicKey(outMint);
          const ts = await this.$store.state.solana.client.getParsedAccountInfo(
            mint
          );

          token = Object.assign(
            cached || {
              address: mint,
              amount: 0,
              decimals: ts?.value?.data?.parsed.info.decimals,
              name: "Unknown",
              symbol: "Unknown",
              programID: ts?.value?.owner.toString(),
            },
            {
              address: new web3.PublicKey(outMint),
              amount: 0,
              decimals: ts?.value?.data?.parsed.info.decimals,
            }
          );
        }

        console.log("setting query outMint", token);
        this.updateTokenB(token);
      }

      this.onTokensSet();
    },

    onTokensSet: function () {
      this.onUpdate();
      this.getTokenBalances();
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getTokenBalances();
    }, 30_000);
  },
  beforeMount() {
    this.handleQueryInput();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.swap-toggle svg:hover {
	color: greenyellow;
	fill: greenyellow;
	cursor: pointer;
	background: transparent;
}
</style>
